import validators from "../../../pages/register/components/register-form/register-form.validators";

export const validateCreateUserForm = async (formValues) => {
  const errors = {};

  try {
    await validators.name()[0].validator(null, {
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    });
  } catch (err) {
    if (err.message.includes("first")) errors.firstName = err.message;
    if (err.message.includes("last")) errors.lastName = err.message;
  }

  try {
    await validators.username(null)[0].validator(null, formValues.username);
  } catch (err) {
    errors.username = err.message;
  }

  try {
    await validators.email(true, null)[0].validator(null, formValues.email);
  } catch (err) {
    errors.email = err.message;
  }

  try {
    await validators.password[0].validator(null, formValues.password);
  } catch (err) {
    errors.password = err.message;
  }

  return Object.keys(errors).length ? errors : null;
};
